import axios from 'axios';

const amazonService = {
  async getAccountBalance() {
    // Appel à l'API backend (adapte l'URL si besoin)
    const response = await axios.get('/api/amazon/balance');
    return response.data;
  },
  async downloadShippingLabel({ sku, quantity, marketplaceId }) {
    // Télécharge le PDF d'étiquette Amazon pour un SKU donné, quantité et marketplaceId
    const response = await axios.get(`/api/amazon/item-labels`, {
      params: { sku, quantity, marketplaceId },
      responseType: 'blob'
    });
    // Crée un lien de téléchargement et déclenche le download
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `label-${sku}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
};

export default amazonService; 